import React from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const appName = process.env.REACT_APP_APP_NAME || 'CRM Automax';

  const navLinkStyle = (path) => ({
    fontSize: '14px',
    fontWeight: '600',
    color: location.pathname === path ? '#3b82f6' : '#475569',
    textDecoration: 'none',
    transition: 'color 0.2s ease',
    cursor: 'pointer'
  });

  return (
    <nav className="marketing-navbar" style={{
      position: 'sticky', top: 0, zIndex: 1000,
      background: 'rgba(255, 255, 255, 0.8)', backdropFilter: 'blur(12px)',
      borderBottom: '1px solid #f1f5f9', padding: '0 48px', height: 'auto', minHeight: '72px',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap'
    }}>
      <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '10px', textDecoration: 'none', color: '#1e293b' }}>
        <div style={{ width: '38px', height: '38px', borderRadius: '10px', background: 'linear-gradient(135deg, #3b82f6, #2563eb)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <ShieldCheck size={20} color="white" />
        </div>
        <span style={{ fontWeight: '800', fontSize: '18px', letterSpacing: '-0.02em' }}>{appName}</span>
      </Link>

      <div style={{ display: 'flex', gap: '16px', alignItems: 'center', flexWrap: 'wrap', padding: '10px 0' }}>
        <Link to="/features" className="nav-link" style={navLinkStyle('/features')}>Features</Link>
        <Link to="/about-us" className="nav-link" style={navLinkStyle('/about-us')}>About Us</Link>
        <Link to="/pricing" className="nav-link" style={navLinkStyle('/pricing')}>Pricing</Link>
        <Link to="/contact" className="nav-link" style={navLinkStyle('/contact')}>Contact</Link>
        <div style={{ width: '1px', height: '24px', background: '#e2e8f0', margin: '0 8px' }} />
        <Link to="/login" style={{ ...navLinkStyle('/login'), color: '#3b82f6' }}>Log in</Link>
        <button onClick={() => navigate('/register')} style={{
          background: '#3b82f6', color: 'white', border: 'none',
          padding: '10px 24px', borderRadius: '10px', fontWeight: '700',
          fontSize: '14px', cursor: 'pointer', transition: 'all 0.2s ease',
          boxShadow: '0 4px 6px -1px rgba(59, 130, 246, 0.2)'
        }}>
          Get Started
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
